import { convertToCommonErrors } from '../../common/utils/errorUtils.js';
import { TypeKeys, generateActionId } from './actionsUtils.js';
import type { CrudAction, ErrorAction, ErrorActionCreator } from './actionsUtils.js';
import type { CampaignsResponse, GenericError } from '../../generated/api/models.js';

export type ClearCampaignsAction = CrudAction<TypeKeys.CLEAR_CAMPAIGNS>;

export interface GetCampaignsQueryParams {
  onlineModel: string;
  salesType: string;
  voucher: string;
}

export interface GetCampaignsAction extends CrudAction<TypeKeys.GET_CAMPAIGNS> {
  params: GetCampaignsQueryParams;
}

export const clearCampaigns = (): ClearCampaignsAction => ({
  id: generateActionId(),
  type: TypeKeys.CLEAR_CAMPAIGNS,
});

export const getCampaigns = (params: GetCampaignsQueryParams): GetCampaignsAction => ({
  params,
  id: generateActionId(),
  type: TypeKeys.GET_CAMPAIGNS,
});

export type GetCampaignsFailedAction = ErrorAction<TypeKeys.GET_CAMPAIGNS_FAILED>;

export const getCampaignsFailed: ErrorActionCreator<TypeKeys.GET_CAMPAIGNS_FAILED> = (
  message: string,
  status: number,
  errors?: GenericError[]
): GetCampaignsFailedAction => ({
  errors: convertToCommonErrors(message, status, errors),
  type: TypeKeys.GET_CAMPAIGNS_FAILED,
});

export interface GetCampaignsFulfilledAction {
  params: GetCampaignsQueryParams;
  response: CampaignsResponse;
  type: TypeKeys.GET_CAMPAIGNS_FULFILLED;
}

export const getCampaignsFulfilled = (
  params: GetCampaignsQueryParams,
  response: CampaignsResponse
): GetCampaignsFulfilledAction => ({
  params,
  response,
  type: TypeKeys.GET_CAMPAIGNS_FULFILLED,
});

export type CampaignsActionTypes =
  | ClearCampaignsAction
  | GetCampaignsAction
  | GetCampaignsFulfilledAction
  | GetCampaignsFailedAction;
